var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8FBFFA",
    d: "M0 3h8l1 4-4 1a424.4 424.4 0 00.375 4.75l.21 2.672C6.005 18.024 6.607 19.774 8 22c2.799 1.4 4.905 1.253 8 1 1.77-1.076 1.77-1.076 3-3 .58-2.962.58-2.962.688-6.188l.199-3.292L20 8l-3-1V3h9c.109 2.876.188 5.748.25 8.625l.102 2.45C26.44 19.564 25.695 22.662 22 27c-2.75 1.875-2.75 1.875-5 3 .325 2.928.596 5.326 2.125 7.875C22.216 39.73 24.485 39.485 28 39c3.163-1.662 3.163-1.662 5-5 .636-3.769.655-7.233 0-11-1.834-2.335-1.834-2.335-4-4-1.176-3.685-1.335-5.283.313-8.813C31 8 31 8 33 7c7.086-.571 7.086-.571 10.5 1.563 2.093 3.4 2.051 5.508 1.5 9.437l-1.938 2.25c-2.331 3.11-2.36 4.283-2.562 8.063-.37 5.956-1.445 10.95-6.04 15.066-3.565 2.337-7.077 3.337-11.41 3.05C18.97 45.576 15.89 44.033 13 41c-1.243-2.783-2.124-5.56-3.004-8.477C8.576 28.928 6.336 27.774 3 26 .902 24.133.078 22.694-.236 19.895c-.06-2.555-.025-5.09.048-7.645l.042-2.691C-.111 7.372-.062 5.186 0 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAE2B",
    d: "M41 7c2.5 1.563 2.5 1.563 4 4 .592 4.068.373 6.27-1.5 9.938-3.044 2.51-4.743 2.746-8.598 2.48C31.87 22.751 30.688 21.565 29 19c-1.176-3.685-1.335-5.283.313-8.813C32.388 6.201 36.263 6.345 41 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationIcon);
export default ForwardRef;